export default {
  imageBox: {
    width: 200,
    height: 200,
    border: '2px solid #3D3E3E',
    float: 'left'
  },
  imageBoxContainer: {
    width: 816,
    display: 'block',
    overlow: 'auto',
    position: 'relative',
    border: '2px solid #2D2D2D',
    whiteSpace: 'nowrap'
  },
  image: {
    width: 200,
    height: 100
  },
  imageRemoveButton: {
    position: 'absolute',
    right: '0px'
  },
  imageRemovalIcon: {
    position: 'relative',
    width: 30,
    height: 30,
    pointerEvents: 'none'
  }
};



// WEBPACK FOOTER //
// ./src/views/CreateNewCase/MultiImageUpload/MultiImageUpload.css.js